<template>
	<div class="home">
		<div class="top">
			<van-popup v-model="show"  get-container="body" :style="{ height: '85%',width: '90%' }"  :closeable="true">
				<div class="">
					<div class="plr20 bggrey  ft28" style="height: 6vh; line-height: 6vh;">申请人信息</div>
					<van-cell-group class="plr20">
						<van-cell title="申请人" :value="showForm.roposerName" />
						<van-cell title="申请人电话" :value="showForm.roposerPhone" />
						<van-cell title="申请人公司类型" :value="showForm.proposerType==1?'工程公司':'矿属单位'" />
						<van-cell v-if="showForm.proposerType==1" title="公司名称" :value="showForm.roposerCompany" />
					</van-cell-group>
					<div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh;">审批者信息</div>
					<van-cell-group class="plr20">
						<van-cell title="审批者" :value="showForm.approverName" />
						<van-cell title="审批者电话" :value="showForm.approverPhone" />
					</van-cell-group>
					<div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh;">报备信息</div>
					<van-cell-group class="plr20">
						<van-cell title="出矿时间" :value="showForm.leaveTime " />
						<van-cell title="出矿地点" :value="showForm.leaveLocName" />
						<van-cell title="车牌号" :value="showForm.truckNo" />
						<van-cell title="出矿事由" :value="showForm.leaveReason" />
					</van-cell-group>
					<div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh;">出矿物资</div>
					<div v-for="(item, index) in showForm.goodsList" :key="index">
						<div class="bgwhite yellow2 ft30 pl30 bor-bt" style="height: 5.5vh; line-height: 5.5vh;">
							物资{{ index + 1 }}</div>
						<van-cell-group class="plr20">
							<van-cell title="物资名称" :value="item.goodsName" />
							<van-cell title="物资规格" :value="item.goodsModel" />
							<van-cell title="物资数量" :value="item.goodsCount" />
							<div class="flex alstart between mt20">
								<span class="ft30 w40">物资照片</span>
								<template v-if="item.goodsPhone.indexOf(',')!=-1">
									<div class="flex flex1 " style="flex-wrap: wrap;">
										<van-image width="20vw" height="20vw" v-for="(i,v) in item.goodsPhone.split(',')" :key="v"
											:src="i"  @click="imagePreview(item,v,1)" style="display: flex; word-wrap: break-word; word-break: normal;padding: 0 1vw 1vw 0; ">
											<template v-slot:loading> 
												<van-loading type="spinner" size="20" />
											</template>
										</van-image>
									</div>
								</template>
								<template v-else>
									<div class="flex flex1 " style="flex-wrap: wrap;">
										<van-image width="20vw" height="20vw" :src="item.goodsPhone"  @click="imagePreview(item,0,1)" style="padding: 0 1vw 1vw 0;">
											<template v-slot:loading> 
												<van-loading type="spinner" size="20" />
											</template>
										</van-image>
									</div>
								</template>
							</div>
						</van-cell-group>
					</div>
					
					<div class="tc ptb10">
						<van-button type="danger" class=" tc" @click="show=false">关闭</van-button>
					</div>
				</div>
			</van-popup>
			<tabs @tabChange="initContent" :list="list">
				<div slot="current">
					<van-pull-refresh class="bggrey" v-model="isLoading" @refresh="onNoRefresh">
						<div class="autoFixed">
							<van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="onNoLoad">
								<van-cell v-for="(item, index) in noCheckedList" :key="index" style="margin-top: 20px; padding: 0">
									<div class="main">
										<div class="history-left" style="margin-top: 20px;">
											<div class="yellow">
												物资出矿报备：
											</div>
											<div class="history-item">
												<span>审核者：</span>
												<span>{{ item.approverName }}</span>
											</div>
											<div class="history-item">
												<span>审核者手机号：</span>
												<span>{{ item.approverPhone }}</span>
											</div>
											<div class="history-item">
												<span>出矿事由：</span>
												<span>{{ item.leaveReason }}</span>
											</div>
											<div class="history-item">
												<span>出矿时间：</span>
												<span>{{ item.leaveTime }}</span>
											</div>
											<div class="history-item">
												<span> 申请人： </span>
												<span>{{ item.roposerName }}</span>
											</div>
											<div class="history-item">
												<span>申请人电话：</span>
												<span>{{ item.roposerPhone }}</span>
											</div>
											<div class="yellow">审核信息：</div>
											<div class="history-item">
												<van-field name="radio" label="审核意见">
													<template #input>
														<van-radio-group v-model="item.myCheckStatus"
															direction="horizontal">
															<van-radio :name="1">同意</van-radio>
															<van-radio :name="2">拒绝</van-radio>
														</van-radio-group>
													</template>
												</van-field>
												<van-field  v-model="item.refuseReason"
													name="原因" label="原因" placeholder="拒绝：必填；同意：非必填" />
											</div>
											
											<div v-if="item.proposerType==1">
												<div class="yellow mt20">领导审核：</div>
												<div v-if="item.myCheckStatus == 1&&openId == item.checkerOpenId" class="history-item flex alstart">
													<div class="" style="width:78%">
														<van-field label-align="center" :required="true" v-model="item.checkerName" name="姓名"
															label="姓名" placeholder="请输入姓名"
															:rules="[{ required: true, message: '请填写姓名' }]" />
														<van-field label-align="center" v-model="item.checkerPhone" name="手机号" label="手机号"
															placeholder="非必填,请输入手机号"
															:rules="[{ required: true, message: '请填写手机号' }]" />
													</div>
													<div class="mt20">
														<van-button class="white" type="primary" size="small" round
															@click="checkPhone(item,1)">添加</van-button>
													</div>
												</div>
											</div>
											<van-row class="bggrey p-box1 mtb20"
												v-for="(list, index1) in item.goodsCheckerList" :key="index1">
												<van-col class="p-label1" span="6">{{list.checkerName}}</van-col>
												<!-- <van-col class="p-value1" span="7">{{list.checkerPhone}}</van-col> -->
												<van-col class="p-value1" span="6" v-if="list.checkStatus==0">待审核
												</van-col>
												<van-col class="p-value1 blue" span="6" v-if="list.checkStatus==1">通过
												</van-col>
												<van-col class="p-value1 red" span="6" v-if="list.checkStatus==2">拒绝
												</van-col>
												<van-col class="p-value1" span="12" v-if="list.checkTime">{{list.checkTime}}
												</van-col>
												<van-col class="p-value1 red" span="5" @click="delChecked(list,item,1)" v-if="openId == item.checkerOpenId&&list.checkerOpenid!=item.checkerOpenId">删除
												</van-col>
											</van-row>
											<van-button type="info" size="small" round @click="examine(item,1)">提交审核
											</van-button>
										</div>
										
										<!-- <div class="hisotry-right"></div> -->
										<van-button plain type="info" size="small" class="userBtn"
											@click="getDetail(item)">详情</van-button>
									</div>
								</van-cell>
							</van-list>
						</div>
					</van-pull-refresh>
				</div>
				<div slot="history">
					<van-pull-refresh class="bggrey" v-model="isLoading" @refresh="onRefresh">
						<div class="autoFixed">
							<van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="onLoad">
								<van-cell v-for="(item, index) in checkedHistoryList" :key="index"
									style="margin-top: 20px; padding: 0">
									<div class="main">
										<div class="history-left" style="margin-top: 20px;">
											<div class="yellow">
												物资出矿报备：
											</div>
											<div class="history-item">
												<span>审核者：</span>
												<span>{{ item.approverName }}</span>
											</div>
											<div class="history-item">
												<span>审核者手机号：</span>
												<span>{{ item.approverPhone }}</span>
											</div>
											<div class="history-item">
												<span>出矿事由：</span>
												<span>{{ item.leaveReason }}</span>
											</div>
											<div class="history-item">
												<span>出矿时间：</span>
												<span>{{ item.leaveTime }}</span>
											</div>
											<div class="history-item">
												<span> 申请人： </span>
												<span>{{ item.roposerName }}</span>
											</div>
											<div class="history-item">
												<span>申请人电话：</span>
												<span>{{ item.roposerPhone }}</span>
											</div>
											<div v-show="item.editing&&openId == item.checkerOpenId">
											<!-- <div v-show="item.editing&&openId == item.openId"> -->
												<div class="yellow">审核信息：</div>
												<div class="history-item">
													<van-field name="radio" label="审核意见">
														<template #input>
															<van-radio-group v-model="item.myCheckStatus"
																direction="horizontal">
																<van-radio :name="1">同意</van-radio>
																<van-radio :name="2">拒绝</van-radio>
															</van-radio-group>
														</template>
													</van-field>
													<van-field v-model="item.refuseReason"
														name="原因" label="原因" placeholder="拒绝：必填；同意：非必填" />
												</div>
												<van-button type="info" size="small" round @click="examine(item,2)">提交审核
												</van-button>
												<div class="yellow mt20">领导审核：</div>
												<div class="history-item flex  alstart">
													<div class="" style="width:78%">
														<van-field label-align="center" :required="true" v-model="item.checkerName" name="姓名"
															label="姓名" placeholder="请输入姓名"
															:rules="[{ required: true, message: '请填写姓名' }]" />
														<van-field label-align="center"   v-model="item.checkerPhone" name="手机号" label="手机号"
															placeholder="非必填,请输入手机号"
															:rules="[{ required: true, message: '请填写手机号' }]" />
													</div>
													<div class="mt20">
														<van-button class="white" type="primary" size="small" round
															@click="checkPhone(item,2)">添加</van-button>
													</div>
												</div>
											</div>
											<div class="w100">
												<van-row class="bggrey p-box1 mtb20 w100"
													v-for="(list, index1) in item.goodsCheckerList" :key="index1">
													<van-col class="p-label1" span="6">{{list.checkerName}}</van-col>
													<!-- <van-col class="p-value1" span="7">{{list.checkerPhone}}</van-col> -->
													<van-col class="p-value1" span="6" v-if="list.checkStatus==0">待审核
													</van-col>
													<van-col class="p-value1 blue" span="6" @click="getRefuseReason(list)" v-if="list.checkStatus==1">通过
													</van-col>
													<van-col class="p-value1 red" span="6" @click="getRefuseReason(list)" v-if="list.checkStatus==2">拒绝
													</van-col>
													<van-col class="p-value1" span="12" v-if="list.createTime">{{list.createTime}}
													</van-col>
													<van-col class="p-value1 red" span="5" @click="delChecked(list,item)" v-if="item.editing&&openId == item.checkerOpenId&&list.checkerOpenid!=item.checkerOpenId">删除
													</van-col>
												</van-row>
											</div>
											
										</div>
										<!-- <van-button v-if="item.showLeave&&openId == item.checkerOpenId&&!item.confirmTime" plain type="info" size="small" class="userBtn2"
											@click="confirmLeave(item)">确认离矿</van-button> -->
										<van-button plain type="info" size="small" class="userBtn"
											@click="getDetail(item)">详情</van-button>
										<van-button v-if="item.edit&&openId == item.checkerOpenId" plain type="primary" size="small" class="userBtn1"
											@click="editDetail(item,index)">{{item.editname}}</van-button>
									</div>
								</van-cell>
							</van-list>
						</div>
					</van-pull-refresh>
				</div>
			</tabs>
		</div>
	</div>
</template>
<script>
	import tabs from '@/components/tabs.vue';
	import {
		tbGoodsChecked,
		tbGoodsCheckedHistory,
		tbGoodsCheckerEdit,
		tbGoodsNoCheckedList,
		
		registerCheck,
		
		tbGoodsAddChecker,
		tbGoodsDelChecker,
		apppointConfirmLeave
	} from '@/apis/api';
	import {
		Toast,
		Dialog,
		ImagePreview,
	} from 'vant';
	import {
		formatTime
	} from '@/utils/index';
	export default {
		data() {
			return {
				openId: localStorage.getItem('openId'),
				noCheckedList: [],
				checkedHistoryList: [],
				pageNo: 1,
				pageSize: 10,
				total: 0,
				isLoading: false,
				loading: false,
				finishedBottom: false,
				show: false,
				list: [{
						name: '未审核',
						type: 'current'
					},
					{
						name: '历史审核',
						type: 'history'
					}
				],
				showForm: {},
				checkStatus: null,
				refuseReason: '',
				// isinterviewee: false,
				// noisinterviewee: false,
				currert:0,
			};
		},
		mounted() {
			document.title = '物资出矿审核';
			this.getNoCheckedList();
		},
		watch: { },
		methods: {
			// 图片预览
			imagePreview(item,list,index){
				var images,arr;
				if(index==1){
					if(item.goodsPhone.indexOf(',')!=-1){
						arr = item.goodsPhone.split(',');
						images = arr;
					}else{
						images = [item.goodsPhone]
					}
				}
				console.log(images);
				ImagePreview({
				  images,
				  startPosition: list,
					closeable: true,
				});
			},
			// 审核
			examine(item,index){
				if(item.myCheckStatus==0){
					return this.$toast("请选择审核意见");
				}
				if(item.myCheckStatus==2&&!item.refuseReason){
					return this.$toast("请填写拒绝原因");
				}
				let goodsCheckerList=[];
				item.goodsCheckerList.forEach((i,v)=>{
					goodsCheckerList.push({
						goodsreportId : i.goodsreportId,
						checkOrder : i.checkOrder,
						checkerName : i.checkerName,
						checkerOpenid : i.checkerOpenid,
						checkerPhone : i.checkerPhone
					})
				})
				let data = {
					goodsreportId:item.id,
					checkStatus:item.myCheckStatus,
					openId:item.openId,
					refuseReason:item.refuseReason,
					goodsCheckerList:goodsCheckerList,
				}
				if(index==1){
					tbGoodsChecked(data).then(res => {
						if (res.code == 200) {
							this.$toast('审核成功');
						} else {
							this.$toast(res.message);
						}
						if(this.currert==0){
							this.getNoCheckedList()
						}else{
							this.getCheckedHistoryList()
						}
					});
				}else{
					tbGoodsCheckerEdit(data).then(res => {
						if (res.code == 200) {
							this.$toast('审核成功');
						} else {
							this.$toast(res.message);
						}
						if(this.currert==0){
							this.getNoCheckedList()
						}else{
							this.getCheckedHistoryList()
						}
					});
				}
			},
			// 确认离矿
			confirmLeave(item){
				Dialog.confirm({
					title: "提示",
					message: `是否确认${item.name}离矿？`,
				}).then(() => {
					apppointConfirmLeave({appointId:item.uid}).then(res => {
						if (res.code == 200) {
							this.$toast(res.message);
						} else {
							this.$toast(res.message);
						}
						if(this.currert==0){
							this.getNoCheckedList()
						}else{
							this.getCheckedHistoryList()
						}
					});
				}).catch(() => {
				});
			},
			// 删除审核人
			delChecked(list,item,index){
				Dialog({ message: "提示" });
				Dialog.confirm({
					title: "提示",
					message: "确认删除审核人吗？",
				}).then(() => {
					if(index==1){
						var flag = item.goodsCheckerList.findIndex(i => {
							return i.checkerOpenid === list.checkerOpenid;
						})
						item.goodsCheckerList.splice(flag,1)
					}else{
						let goodsChecker = {
							goodsreportId: list.goodsreportId,
							checkOrder: list.checkOrder,
							checkerName: list.checkerName,
							checkerOpenid: list.checkerOpenid,
							checkerPhone:list.checkerPhone,
						}
						tbGoodsDelChecker(goodsChecker).then(res => {
							if (res.code == 200) {
								this.$toast(res.message);
							} else {
								this.$toast(res.message);
							}
							if(this.currert==0){
								this.getNoCheckedList()
							}else{
								this.getCheckedHistoryList()
							}
						});
					}
					
				}).catch(() => {
				});;
			},
			// 添加审核人
			checkPhone(item,index) {
				let registerCheckModel = {
					name: item.checkerName,
					phone: item.checkerPhone
				};
				registerCheck(registerCheckModel).then(res => {
					if (res.code == 200) {
						let haveOpenId=0;
						console.log(item.goodsCheckerList);
						item.goodsCheckerList.forEach((i, v) => {
							if(i.checkerOpenid == res.result.openId){
								haveOpenId++
							}
						});
						if(haveOpenId>0){
							Toast('审核人存在');
						}else{
							if(index==1){
								item.goodsCheckerList.push({
									goodsreportId: item.goodsCheckerList[0].goodsreportId,
									checkOrder: item.goodsCheckerList.length,
									checkStatus: 0,
									checkerName: res.result.personName,
									checkerOpenid: res.result.openId,
									checkerPhone: res.result.phoneNum,
									refuseReason: null,
								})
								this.$toast('添加成功');
							}else{
								let goodsChecker ={
									goodsreportId: item.goodsCheckerList[0].goodsreportId,
									checkOrder: item.goodsCheckerList.length,
									checkerName: res.result.personName,
									checkerOpenid: res.result.openId,
									checkerPhone: res.result.phoneNum,
								}
								tbGoodsAddChecker(goodsChecker).then(res => {
									if (res.code == 200) {
										Toast(res.message);
									}else{
										Toast(res.message);
									}
									if(this.currert==0){
										this.getNoCheckedList()
									}else{
										this.getCheckedHistoryList()
									}
								});
							}
						}
					} else {
						this.$toast(res.message);
					}
				});
			},
			// 拒绝原因
			getRefuseReason(list) {
				Dialog.alert({
				  title: '原因',
				  message: list.refuseReason,
				  theme: 'round-button',
				}).then(() => {});
			},
			// 历史审核刷新
			getCheckedHistoryList() {
				this.onRefresh(1);
			},
			// 历史审核刷新
			onRefresh(index) {
				this.pageNo = 1;
				this.pageSize = 10;
				this.isLoading = true;
				tbGoodsCheckedHistory({
					pageNo: this.pageNo,
					pageSize: this.pageSize
				}).then(res => {
					this.isLoading = false;
					this.loading = false;
					if(res.code==200){
						if (index != 1) {
							Toast('刷新成功');
						}
						res.result.records.forEach((i,v)=>{
							// i.showLeave = i.goodsCheckerList.every(x=>x.checkStatus==1)
							// i.name = i.visitors.map(x=>x.personName).join('、')
							i.goodsCheckerList.forEach((x,y)=>{
								console.log(this.openId);
								console.log(x.checkerOpenid);
								if(this.openId == x.checkerOpenid){
									i.myCheckStatus = x.checkStatus
								}
								if((y==0&&x.checkStatus==2)||(y!=0&&x.checkStatus!=0)){
									i.edit=false;
									i.editing=false;
								}else{
									i.edit=true;
									i.editing=false;
									i.editname='编辑';
								}
							})
						})
						this.checkedHistoryList = res.result.records;
						this.total = res.result.total;
						if (this.checkedHistoryList.length == this.total) {
							this.finishedBottom = true;
						}
					}else{
						this.finishedBottom = true;
					}
				});
			},
			// 历史审核列表上拉加载
			onLoad(e) {
				console.log('e');
				if (this.isLoading) return;
				this.pageNo++;
				tbGoodsCheckedHistory({
					pageNo: this.pageNo,
					pageSize: this.pageSize
				}).then(res => {
					this.isLoading = false;
					this.loading = false;
					if(res.code==200){
						res.result.records.forEach((i,v)=>{
							// i.showLeave = i.goodsCheckerList.every(x=>x.checkStatus==1)
							// i.name = i.visitors.map(x=>x.personName).join('、')
							i.goodsCheckerList.forEach((x,y)=>{
								if(this.openId == x.checkerOpenid){
									i.myCheckStatus = x.checkStatus
								}
								if((y==0&&x.checkStatus==2)||(y!=0&&x.checkStatus!=0)){
									i.edit=false;
									i.editing=false;
								}else{
									i.edit=true;
									i.editing=false;
									i.editname='编辑';
								}
							})
						})
						this.checkedHistoryList = this.checkedHistoryList.concat(res.result.records);
						if (this.checkedHistoryList.length == this.total) {
							this.finishedBottom = true;
						}
					}else{
						this.finishedBottom = true;
					}
				});
			},
			// 获取未审核刷新
			getNoCheckedList() {
				this.onNoRefresh(1);
			},
			// 获取未审核刷新
			onNoRefresh(index) {
				this.pageNo = 1;
				this.pageSize = 10;
				this.isLoading = true;
				tbGoodsNoCheckedList({
					pageNo: this.pageNo,
					pageSize: this.pageSize
				}).then(res => {
					this.isLoading = false;
					this.loading = false;
					if(res.code==200){
						if (index != 1) {
							Toast('刷新成功');
						}
						res.result.records.forEach((i,v)=>{
							i.goodsCheckerList.forEach((x,y)=>{
								if(this.openId == x.checkerOpenid){
									i.myCheckStatus = x.checkStatus
								}
							})
						})
						this.noCheckedList = res.result.records;
						this.total = res.result.total;
						if (this.noCheckedList.length == this.total) {
							this.finishedBottom = true;
						}
					}else{
						this.finishedBottom = true;
					}
				});
			},
			// 未审核列表上拉加载
			onNoLoad(e) {
				if (this.isLoading) return;
				console.log(66666666);
				this.pageNo++;
				tbGoodsNoCheckedList({
					pageNo: this.pageNo,
					pageSize: this.pageSize
				}).then(res => {
					this.isLoading = false;
					this.loading = false;
					if(res.code==200){
						res.result.records.forEach((i,v)=>{
							i.goodsCheckerList.forEach((x,y)=>{
								if(this.openId == x.checkerOpenid){
									i.myCheckStatus = x.checkStatus
								}
							})
						})
						this.noCheckedList = this.noCheckedList.concat(res.result.records);
						if (this.noCheckedList.length == this.total) {
							this.finishedBottom = true;
						}
					}else{
						this.finishedBottom = true;
					}
				});
			},
			// 详情
			getDetail(item) {
				this.show = true;
				this.showForm = item;
			},
			// 编辑
			editDetail(item) {
				if(item.editing==false){
					item.editing = true;
					item.editname= '取消';
				}else{
					item.editing = false;
					item.editname = '编辑';
				}
				this.$forceUpdate()
			},

			initContent(value) {
				this.currert = value;
				this.pageNo= 1;
				this.pageSize= 10;
				this.total= 0;
				this.isLoading= false;
				this.loading= false;
				this.finishedBottom= false;
				if (value == 0) {
					this.getNoCheckedList();
				} else {
					this.getCheckedHistoryList();
				}
			}
		},
		components: {
			tabs
		}
	};
</script>

<style lang="less" scoped>
	.autoFixed {
		background: #f3f3f3;
		min-height: 100vh;
		padding: 0 20px;
		position: relative;

		.userBtn {
			position: absolute;
			right: 20px;
			top: 20px;
			width: 94px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			background: none;
			border-radius: 5px;
			color: #4597ff;
		}
		.userBtn2 {
			position: absolute;
			right: 120px;
			top: 20px;
			width: 134px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			background: none;
			border-radius: 5px;
			color: #4597ff;
		}
		.userBtn1 {
			position: absolute;
			right: 20px;
			top: 85px;
			width: 94px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			background: none;
			border-radius: 5px;
			color: #55aa7f;
		}

		.main {
			box-sizing: content-box;
			background: #ffffff;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			width: 100%;
			border-radius: 5px;
			padding: 0 24px 10px;
			box-sizing: border-box;
			position: relative;

			.roomName {
				position: absolute;
				left: 20px;
				top: 20px;
				color: #64b0ff;
				font-weight: bold;
			}

			.hisotry-right {
				img {
					width: 150px;
					height: 130px;
				}
			}

			.history-item {
				margin-bottom: 15px;

				span {
					font-size: 28px;
					color: #333;
				}
			}
		}
	}

	.p-box1 {
		min-height: 48px;
		line-height: 48px;
		font-size: 26px;
		background: #f5f5f5;
		color: #1b1b1b;
		border-bottom: 4upx solid #fff;
		position: relative;

		.p-label1 {
			padding: 6px 0;
			min-height: 48px;
			line-height: 48px;
			word-break: break-word;
		}

		.p-value1 {
			border-left: 1px solid #fff;
			padding: 6px 4px;
			min-height: 48px;
			line-height: 48px;
			word-break: break-word;
		}
	}
</style>
